import { render, staticRenderFns } from "./SuggestionListTableTr.vue?vue&type=template&id=812fe4de&scoped=true&"
var script = {}
import style0 from "./SuggestionListTableTr.vue?vue&type=style&index=0&id=812fe4de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812fe4de",
  null
  
)

export default component.exports